"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdTelematicsService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
class TpdTelematicsService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
        this.telematicsVehiclesHeader = {
            accept: "application/json",
            service_type: "Vehicle",
            api_key: "zje898HMI2P8aQy413mbz7euA0X93GiD",
            company_id: "unipolsai",
        };
        this.telematicsCrashesHeader = {
            accept: "application/json",
            service_type: "Claim",
            api_key: "zje898HMI2P8aQy413mbz7euA0X93GiD",
            company_id: "unipolsai",
        };
        this.headers = {
            "x-unipol-canale": "AR",
        };
        this.telematicContract = {
            vehicleVAS: (plate) => {
                const request = new request_1.Request(`telematici/auto/v1/vehicles/IT-${plate}/vehicleVAS`, { headers: this.telematicsVehiclesHeader });
                return this.commonNetworkService.get(request.completeUrl, request.headers);
            }
        };
    }
}
exports.TpdTelematicsService = TpdTelematicsService;
